import { render, staticRenderFns } from "./ClientPersonalProfile.vue?vue&type=template&id=70970135&scoped=true&"
import script from "./ClientPersonalProfile.vue?vue&type=script&lang=js&"
export * from "./ClientPersonalProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClientPersonalProfile.vue?vue&type=style&index=0&id=70970135&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70970135",
  null
  
)

export default component.exports